export default __webpack_public_path__ + "media/images/images/map/leaflet/images/marker-shadow-a0c6cc1401c107b501efee6477816891.png";